import {
	MimaButton,
	MimaDropdown,
	MimaInput,
	MimaText,
} from '../../components';
import styles from '../../assets/styles/Inventory/Checkout.module.scss';
import { BsFillArrowLeftCircleFill } from 'react-icons/bs';
import countries from '../../utils/countries.json';
import Img1 from '../../assets/img/checkout1.jpg';
import Img2 from '../../assets/img/checkout2.jpg';
import Img3 from '../../assets/img/checkout3.jpg';
import Logo from '../../assets/img/mima-logo.png';
import Twoods from '../../assets/img/Twoods.png';
import { invoiceStore } from '../../stores';
import { Formik } from 'formik';
import React from 'react';

const Checkout = ({
	activeImg,
	setActiveImage,
	payInfo,
	showPayInfo,
	goBack,
	pay,
	showPay,
	loading,
	onSubmit,
	customerDetailsValidation,
}) => {
	const data = [
		{ key: 'name', value: 'name' },
		{ key: 'Class', value: 'Class' },
		{ key: 'people', value: 'people' },
	];

	let mainImage;

	if (activeImg === 'Image1') {
		mainImage = Img1;
	}
	if (activeImg === 'Image2') {
		mainImage = Img2;
	}
	if (activeImg === 'Image3') {
		mainImage = Img3;
	}

	return (
		<div className={styles.main}>
			{!payInfo && (
				<>
					<div className={styles.business}>Tosho Woods</div>
					<div className={styles.product}>
						<div className={styles.product__images}>
							<img
								src={Twoods}
								alt="Main image"
								className={styles.product__images_main}
							/>
						</div>
						<div className={styles.product__desc}>
							<MimaText variant="subtitleBold">
								Brand Positioning For Bridal Designers
							</MimaText>
							<MimaText variant="small" mb={2}>
								by Tosho Woods
							</MimaText>

							<MimaText mb={2} variant="small">
								Brand Positioning is a course that helps you identify a Unique
								Image Perception for your Brand which in turn creates a direct
								bridge between you and your dream clientele. In an eight-week
								course from the comfort of your own home. You'll learn the
								secrets of capturing the essence of a Bridal outfit in this
								course. I will broaden your horizon of knowledge of the Bridal
								Design which will in turn guide you in finding your Design
								niche. You will learn everything about Bridal Design from
								Silhouettes, Cuts, to Fabric and its usage, detailing and
								everything that makes a perfect bridal look. These are the new
								skills that you can take with you as you explore new projects,
								face challenges, and design for Real Brides. You will now create
								internationally acceptable and viable designs and learn how to
								use this new insight to hold your own market position.
							</MimaText>
							<div className={styles.product__desc_beside}>
								<div className={styles.product__desc_amt}>
									<MimaText variant="small">Price</MimaText>
									{/* <p>Early Bird(Ends Dec 1, 2022): &#8358; 200,000</p> */}
									<p>Fee: $1,000/&#8358; 750,000</p>
								</div>
								{/* <MimaInput labelTitle="Quantity" type="number" width={10} placeholder={1} ml={3}/> */}
							</div>

							{/* <div className={styles.product__desc_beside}>
								<MimaDropdownFilter labelTitle="Color" data={data} />
								<MimaDropdownFilter labelTitle="Size" data={data} />
								<MimaDropdownFilter labelTitle="Quantity" data={data} />
							</div> */}
							<div className={styles.product__desc_beside}>
								{/* <MimaButton title="Add Item" variant="filter" width={20} /> */}
								<MimaButton
									title="Proceed to Pay"
									width={20}
									buttonColor="var(--color-primary)"
									onClick={showPayInfo}
								/>
							</div>
							{/* <MimaText variant="smallBold">
								3-5 working days for delivery of this product.
							</MimaText> */}
						</div>
					</div>
				</>
			)}
			{payInfo && (
				<>
					<div className={styles.order__top}>
						<BsFillArrowLeftCircleFill onClick={goBack} />
						<MimaText variant="bodyBold" color="var(--color-primary)">
							Tosho Woods
						</MimaText>
					</div>
					<div className={styles.order}>
						<>
							{!pay && (
								<>
									<div className={styles.order__customer}>
										<MimaText variant="bodyBold">Billing Info</MimaText>

										<Formik
											initialValues={{
												fullname: '',
												mobile: '',
												email: '',
												address: '',
												country: '',
												state: '',
												promoCode: '',
											}}
											validationSchema={customerDetailsValidation()}
											onSubmit={onSubmit}>
											{({
												handleChange,
												handleBlur,
												handleSubmit,
												setFieldValue,
												values,
												errors,
												touched,
											}) => (
												<div>
													<MimaInput
														type="text"
														labelTitle="Full Name"
														placeholder="Enter your Full Name"
														name="fullname"
														mb={2}
														value={values.fullname}
														onChange={handleChange}
														onBlur={handleBlur}
														error={errors.fullname}
														touched={touched.fullname}
													/>

													<MimaInput
														type="text"
														labelTitle="Phone Number"
														placeholder="Enter Your Phone number"
														name="mobile"
														mb={2}
														value={values.mobile}
														onChange={handleChange}
														onBlur={handleBlur}
														error={errors.mobile}
														touched={touched.mobile}
													/>
													<MimaInput
														type="email"
														labelTitle="Email Address"
														placeholder=" Enter your Email address"
														name="email"
														mb={2}
														value={values.email}
														onChange={handleChange}
														onBlur={handleBlur}
														error={errors.email}
														touched={touched.email}
													/>
													<MimaDropdown
														labelTitle="Country"
														name="country"
														value={values.country}
														currentValue={values.country}
														placeholder={values.country}
														id="countryy"
														onChange={data => {
															setFieldValue('country', data.key);
														}}
														data={countries.map(value => {
															return {
																key: value.country,
																value: value.country,
															};
														})}
														touched={touched.country}
													/>
													<MimaDropdown
														labelTitle="State"
														name="state"
														currentValue={values.state}
														placeholder={values.state}
														value={values.state}
														id="state"
														onChange={data => {
															setFieldValue('state', data.key);
														}}
														data={
															countries
																.find(value => value.country === values.country)
																?.states.map(state => {
																	return {
																		key: state,
																		value: state,
																	};
																}) || []
														}
														touched={touched.state}
													/>
													{/* <MimaInput
                                                        type="text"
                                                        labelTitle="Promo Code"
                                                        placeholder="Enter your promo Code"
                                                        name="promoCode"
                                                        mb={2}
                                                        value={values.promoCode}
                                                        onChange={handleChange}
                                                        onBlur={handleBlur}
                                                        error={errors.promoCode}
                                                        touched={touched.promoCode}
                                                    /> */}
													<MimaButton
														title="Make Payment"
														loading={loading}
														type="submit"
														onClick={handleSubmit}
													/>
												</div>
											)}
										</Formik>
									</div>
								</>
							)}

							{pay && (
								<>
									<div className={styles.order__summary}>
										<MimaText mb={1}>
											To Pay in Naira, Kindly make a transfer of{' '}
											<span>&#8358;{invoiceStore.selectedInvoice.deposit}</span>{' '}
											to
										</MimaText>
										<MimaText variant="bodyBold" mb={1}>
											Kuda Bank
										</MimaText>
										<MimaText variant="bodyBold" mb={1}>
											Account Number: 2046790691{' '}
										</MimaText>
										<MimaText variant="bodyBold" mb={1}>
											Account Name: Tosho Woods
										</MimaText>
										<MimaText mb={3}>
											To track your payment add{' '}
											<span>INV-{invoiceStore.selectedInvoice.number}</span> as
											narration when making payment.
										</MimaText>
										<MimaText mb={3}>
											To Pay in Dollar, Kindly make a transfer of{' '}
											<span>$1,000</span> to
										</MimaText>
										<MimaText variant="bodyBold" mb={1}>
											Access Bank
										</MimaText>
										<MimaText variant="bodyBold" mb={1}>
											Account Number: 1501244991{' '}
										</MimaText>
										<MimaText variant="bodyBold" mb={1}>
											Account Name: Tosho Woods Designs{' '}
										</MimaText>
										<MimaText variant="bodyBold" mb={1}>
											Swift Code: ABNGNGLA{' '}
										</MimaText>
										<MimaText variant="bodyBold" mb={1}>
											Address: 64, Adeola Odeku, Victoria Island , Lagos{' '}
										</MimaText>
										<MimaText mb={3}>
											To track your payment add{' '}
											<span>INV-{invoiceStore.selectedInvoice.number}</span> as
											narration when making payment.
										</MimaText>
										<MimaText variant="bodyBold" align="center" mb={3}>
											OR
										</MimaText>

										<MimaText mb={1}>
											Click the button below to pay by card;{' '}
											<span>charges apply</span>
										</MimaText>
										<a href={invoiceStore.selectedInvoice.paymentUrl}>
											<MimaButton title="Pay via Card" />
										</a>
									</div>
								</>
							)}
						</>

						{/* <div className={styles.order__summary}>
							<table>
								<thead>
									<tr>
										<th>Order Summary</th>
										<th>Price</th>
									</tr>
								</thead>
								<tbody>
									<tr>
										<td>Butterfly Top- Blue, Medium x 1 </td>
										<td>N5,000.00</td>
									</tr>
									<tr>
										<td>Sub-total </td>
										<td>N5,000.00</td>
									</tr>
									<tr>
										<td>shipping </td>
										<td className={styles.order__summary_location}>
											<span>
												<RCB />
												<span>
													3-4 Working Days (Except Sundays & Public Holidays):
													N1,200
												</span>
											</span>
											<span>
												<RCB />
												<span>
													EXTREME LOCATIONS (3-5 Working Days) Alimsho, Badagry,
													Iju Ishaga, Ojo Epe Division Epe, Ibeju-Lekki, Ikorodu
													Agbado/Oke-Odo, Agboyi, Ketu, Ifelodun, Igando/Ikotun,
													Ikorodu North, Ikorodu, Awoyaya, Command Ipaja, Ojodu
													Berger: N1,800
												</span>
											</span>
										</td>
									</tr>
									<tr>
										<td>VAT </td>
										<td>N218.00</td>
									</tr>
									<tr>
										<td>Total </td>
										<td>N5,218.00</td>
									</tr>
								</tbody>
							</table>
						</div> */}
					</div>
				</>
			)}
			<div className={styles.mima}>
				<p>Powered by</p> <img src={Logo} className={styles.mima__logo} />
			</div>
		</div>
	);
};

export default Checkout;